import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  background-color: #f8fafc;
  padding: 120px 30px 80px 30px;
`;


export const PageHeader = styled.h1`
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 8px;
  text-align: center; /* ← isso centraliza o texto */
`;


export const FilterRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin: 20px auto;
  padding: 16px;
  background-color: #f8fafc;
  border-radius: 10px;
  max-width: 1100px;
`;


export const TableWrapper = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.05);
  overflow-x: auto;

  table {
    width: 100%;
    border-collapse: collapse;
    min-width: 800px;

    th, td {
      padding: 14px 16px;
      text-align: left;
      font-size: 14px;
    }

    thead {
      background-color: #f1f5f9;
      color: #475569;
    }

    tbody tr {
      border-top: 1px solid #e2e8f0;
    }

    .status {
      padding: 4px 10px;
      border-radius: 6px;
      font-size: 12px;
      text-transform: capitalize;
      font-weight: 600;
    }

    .pendente {
      background-color: #fef9c3;
      color: #92400e;
    }

    .pago {
      background-color: #dcfce7;
      color: #166534;
    }

    .vencido {
      background-color: #fee2e2;
      color: #991b1b;
    }

    .edit {
      color: #2563eb;
      background: none;
      border: none;
      cursor: pointer;
      margin-right: 8px;
    }

    .delete {
      color: #dc2626;
      background: none;
      border: none;
      cursor: pointer;
    }

    .empty {
      text-align: center;
      font-style: italic;
      color: #94a3b8;
      padding: 20px;
    }
  }
`;


export const AddButton = styled.button`
  background-color: #2563eb;
  color: white;
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  font-weight: 500;
  transition: background-color 0.2s;

  &:hover {
    background-color: #1d4ed8;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background-color: white;
  border-radius: 12px;
  padding: 24px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`;

export const ModalTitle = styled.h2`
  font-size: 24px;
  margin-bottom: 24px;
  color: #1e293b;
  padding-bottom: 16px;
  border-bottom: 1px solid #e2e8f0;
`;

export const Input = styled.input`
  padding: 8px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  font-size: 14px;
  margin: 0 5px;

  &:focus {
    outline: none;
    border-color: #2563eb;
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);
  }
`;

export const Select = styled.select`
  padding: 8px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  font-size: 14px;
  margin: 0 5px;
  background-color: white;

  &:focus {
    outline: none;
    border-color: #2563eb;
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);
  }
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e2e8f0;
`;

export const ButtonCancelar = styled.button`
  background-color: #f1f5f9;
  color: #64748b;
  padding: 8px 20px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;

  &:hover {
    background-color: #e2e8f0;
  }
`;

export const ButtonSalvar = styled.button`
  background-color: #2563eb;
  color: white;
  padding: 8px 20px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;

  &:hover {
    background-color: #1d4ed8;
  }
`;

export const StatusBadge = styled.span`
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  background-color: ${props => 
    props.status === 'pendente' ? '#fef3c7' : 
    props.status === 'recebido' ? '#d1fae5' : 
    props.status === 'atrasado' ? '#fee2e2' : '#e5e7eb'};
  color: ${props => 
    props.status === 'pendente' ? '#92400e' : 
    props.status === 'recebido' ? '#065f46' : 
    props.status === 'atrasado' ? '#b91c1c' : '#374151'};
`;

export const DashboardCard = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const DashboardCardTitle = styled.h3`
  margin-bottom: 15px;
  color: #334155;
`;

export const NextPaymentCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border-left: ${props => props.isLate ? '4px solid #ef4444' : '4px solid #f59e0b'};
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const TableHeader = styled.th`
  text-align: left;
  padding: 12px 16px;
  background-color: #f8fafc;
  color: #64748b;
  font-weight: 600;
  font-size: 14px;
  border-bottom: 1px solid #e2e8f0;
`;

export const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f8fafc;
  }
  
  &:hover {
    background-color: #f1f5f9;
  }
`;

export const TableCell = styled.td`
  padding: 12px 16px;
  border-bottom: 1px solid #e2e8f0;
  font-size: 14px;
`;

export const ActionButton = styled.button`
  background-color: transparent;
  color: ${props => props.color || '#64748b'};
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
  
  &:hover {
    background-color: #f1f5f9;
  }
`;

export const RecomendationsContainer = styled.div`
  background-color: #fef3c7;
  padding: 20px;
  border-radius: 10px;
  margin: 20px auto;
  max-width: 900px;
`;

export const RecomendationsTitle = styled.h3`
  margin-bottom: 10px;
  color: #92400e;
`;

export const RecomendationsList = styled.ul`
  margin: 0;
  padding-left: 20px;
  color: #92400e;
`;
export const ActionPanel = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;  // ← aqui está o ajuste principal
  align-items: center;
  gap: 15px;
  margin: 20px auto;
  max-width: 1200px;
`;




export const ExportButton = styled.button`
  background-color: #15803d;
  color: white;
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #166534;
  }
`;

export const BatchActionButton = styled.button`
  background-color: #0284c7;
  color: white;
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #0369a1;
  }
`;

export const ViewToggleButton = styled.button`
  background-color: ${props => props.active ? '#2563eb' : '#e5e7eb'};
  color: ${props => props.active ? 'white' : '#374151'};
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: ${props => props.active ? '#1d4ed8' : '#d1d5db'};
  }
`;

export const SummaryCard = styled.div`
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 200px;
  text-align: center;
`;

export const SummaryLabel = styled.div`
  font-size: 16px;
  color: ${props => props.color || '#64748b'};
  font-weight: 600;
`;

export const SummaryValue = styled.div`
  font-size: 24px;
  font-weight: 700;
  margin-top: 8px;
`;


export const SummaryCardsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 30px 0 20px;
`;

export const NextPaymentsContainer = styled.div`
  margin: 30px auto;
  max-width: 1000px;
  background-color: #f8fafc;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

export const SectionTitle = styled.h3`
  margin-bottom: 15px;
  color: #334155;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 10px;
`;

export const NextPaymentsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const DashboardGrid = styled.div`
  margin: 30px auto 40px;
  max-width: 1200px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
  gap: 20px;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 20px;
  color: #64748b;
`;

export const AnimatedCard = styled.div`
  transition: all 0.3s ease;
  transform: scale(1);
  &:hover {
    transform: scale(1.02);
  }
`;

export const FilterLabel = styled.label`
  font-size: 14px;
  color: #475569;
  margin-bottom: 6px;
`;

export const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 200px;
  margin-bottom: 16px;
`;

export const AdvancedFiltersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin: 20px 0;
`;

export const Tab = styled.button`
  background: none;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  font-weight: 600;
  color: #334155;
  border-bottom: 2px solid transparent;

  &.active {
    border-bottom: 2px solid #2563eb;
    color: #2563eb;
  }
`;

export const TabsContainer = styled.div`
  display: flex;
  border-bottom: 1px solid #e2e8f0;
  margin-bottom: 20px;
`;

export const TabContent = styled.div`
  padding: 20px 0;
`;

export const Tag = styled.span`
  background-color: #e0f2fe;
  color: #0369a1;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  margin: 4px;
`;

export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const TagInput = styled.input`
  border: 1px solid #cbd5e1;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 14px;
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  resize: vertical;
  font-size: 14px;
`;

export const PriorityBadge = styled.span`
  padding: 4px 10px;
  border-radius: 12px;
  background-color: ${props =>
    props.priority === 'alta' ? '#fee2e2' :
    props.priority === 'media' ? '#fef9c3' : '#d1fae5'};
  color: ${props =>
    props.priority === 'alta' ? '#b91c1c' :
    props.priority === 'media' ? '#92400e' : '#065f46'};
  font-size: 12px;
  font-weight: 500;
`;

export const KpiCard = styled.div`
  padding: 16px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  text-align: center;
`;

export const ActionButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
`;

export const BadgeContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 10px;
`;

export const AttachmentArea = styled.div`
  background-color: #f1f5f9;
  padding: 12px;
  border-radius: 8px;
  border: 2px dashed #cbd5e1;
`;

export const AttachmentItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  margin-bottom: 8px;
`;

export const CommunicationList = styled.ul`
  padding-left: 20px;
  list-style: disc;
`;

export const CommunicationItem = styled.li`
  font-size: 14px;
  color: #334155;
`;

export const FilterToggle = styled.button`
  background-color: #e2e8f0;
  color: #334155;
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #cbd5e1;
  }
`;

export const FileUploadArea = styled.div`
  background-color: #f1f5f9;
  border: 2px dashed #94a3b8;
  padding: 20px;
  border-radius: 12px;
  text-align: center;
  color: #475569;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #e2e8f0;
  }
`;